module.exports = __webpack_public_path__ + "img/fukumatu_food_title.e13b74b0.png";